module.exports = __webpack_public_path__ + "img/pinwhite.e2556f2c.svg";